import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Star } from "lucide-react";

export default function Loyalty() {
  const [data, setData] = useState({ account: null, ledger: [] });
  useEffect(() => { api.get("/dealer/loyalty").then(({ data }) => setData(data)); }, []);
  const a = data.account || {};
  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-4 sm:space-y-6" data-testid="dealer-loyalty">
      <div><h1 className="font-display text-2xl sm:text-3xl font-black flex items-center gap-2"><Star className="w-7 h-7 text-violet-600" /> Loyalty</h1><p className="text-muted-foreground">Earn 2% in points on every paid order. Redeem up to 20% of any order at checkout. 1 point = ₹1.</p></div>
      <div className="grid sm:grid-cols-3 gap-4">
        <Card><CardContent className="p-5"><div className="label-overline">Current balance</div><div className="font-display text-3xl sm:text-4xl font-black text-violet-700 mt-2">{a.balance || 0}</div></CardContent></Card>
        <Card><CardContent className="p-5"><div className="label-overline">Lifetime earned</div><div className="font-display text-2xl sm:text-3xl font-black mt-2">{a.lifetime_earned || 0}</div></CardContent></Card>
        <Card><CardContent className="p-5"><div className="label-overline">Lifetime redeemed</div><div className="font-display text-2xl sm:text-3xl font-black mt-2">{a.lifetime_redeemed || 0}</div></CardContent></Card>
      </div>
      <div className="surface-card p-4 overflow-x-auto">
        <h2 className="font-display text-lg font-bold mb-3">Ledger</h2>
        <Table>
          <TableHeader><TableRow><TableHead>When</TableHead><TableHead>Kind</TableHead><TableHead>Δ</TableHead><TableHead>Balance after</TableHead><TableHead>Reference</TableHead></TableRow></TableHeader>
          <TableBody>
            {data.ledger.map((line) => (
              <TableRow key={line.id} data-testid={`loyalty-${line.id}`}>
                <TableCell className="font-mono text-xs">{new Date(line.at).toLocaleString()}</TableCell>
                <TableCell><Badge variant="outline">{line.kind}</Badge></TableCell>
                <TableCell className={line.delta >= 0 ? "text-emerald-700 font-semibold" : "text-red-700 font-semibold"}>{line.delta > 0 ? "+" : ""}{line.delta}</TableCell>
                <TableCell>{line.balance_after}</TableCell>
                <TableCell className="font-mono text-[10px]">{line.ref}</TableCell>
              </TableRow>
            ))}
            {data.ledger.length === 0 && <TableRow><TableCell colSpan={5} className="text-center text-muted-foreground py-10">No transactions yet — your first paid order will earn points.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </div>
    </div>
  );
}
